import { useState } from "react";
import { Star, Loader2 } from "lucide-react";
import { toast } from "sonner";
import papi, { perr } from "@/lib/portalApi";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const LABELS = ["", "Pas du tout satisfait", "Peu satisfait", "Correct", "Satisfait", "Très satisfait"];

export default function StepRating({ pid, step, onDone }) {
  const r = step.rating;
  const [note, setNote] = useState(r?.note || 0);
  const [hover, setHover] = useState(0);
  const [com, setCom] = useState(r?.commentaire || "");
  const [edit, setEdit] = useState(!r);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await papi.post(`/projects/${pid}/steps/${step.id}/rating`, { note, commentaire: com }); toast.success("Merci pour votre avis !"); setEdit(false); onDone(); }
    catch (e) { toast.error(perr(e)); } finally { setBusy(false); }
  };
  const shown = hover || note;
  return (
    <div className="mt-3 rounded-xl bg-emerald-50/60 border border-emerald-100 p-3" data-testid={`portal-rating-${step.id}`}>
      <p className="text-xs font-medium text-[#076633]">{r && !edit ? "Votre avis sur cette étape" : "Êtes-vous satisfait de cette étape ?"}</p>
      <div className="flex items-center gap-1 mt-1.5" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" disabled={!edit} onMouseEnter={() => edit && setHover(n)} onClick={() => setNote(n)}
            className="p-0.5 transition-transform enabled:hover:scale-110" data-testid={`portal-rating-${step.id}-star-${n}`} aria-label={`${n} étoile(s)`}>
            <Star className={`h-6 w-6 ${n <= shown ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
          </button>
        ))}
        {shown > 0 && <span className="text-xs text-slate-600 ml-2">{LABELS[shown]}</span>}
      </div>
      {edit ? <>
        {note > 0 && <Textarea value={com} onChange={(e) => setCom(e.target.value)} placeholder="Un commentaire ? (facultatif)" rows={2} className="mt-2 bg-white text-sm" data-testid={`portal-rating-${step.id}-comment`} />}
        <div className="flex gap-2 mt-2">
          <Button size="sm" disabled={!note || busy} onClick={save} className="rounded-full bg-[#076633] hover:bg-[#065a2c] text-white" data-testid={`portal-rating-${step.id}-save`}>{busy && <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" />}Envoyer mon avis</Button>
          {r && <Button size="sm" variant="ghost" onClick={() => { setEdit(false); setNote(r.note); setCom(r.commentaire); }} className="rounded-full">Annuler</Button>}
        </div>
      </> : <>
        {r?.commentaire && <p className="text-xs text-slate-600 italic mt-1">« {r.commentaire} »</p>}
        <button onClick={() => setEdit(true)} className="text-xs text-[#076633] underline mt-1" data-testid={`portal-rating-${step.id}-edit`}>Modifier mon avis</button>
      </>}
    </div>
  );
}
